const VERSION = '2.0.24a'
export default VERSION
